
const routing = [
    {
        path: "/routing/log",
        component: resolve =>
          require(["@/manage/views/routing/log.vue"], resolve),
        name: "分账日志",
        meta: {
          title: "分账日志",
          affix: true
        }
      },
      {
        path: "/routing/member",
        component: resolve =>
          require(["@/manage/views/routing/member.vue"], resolve),
        name: "分账接受方",
        meta: {
          title: "分账接受方",
          affix: true
        }
      }
  ];
  export default routing;
  
